module.exports = __webpack_public_path__ + "img/06-main.5fcbf239.svg";